<!-- eslint-disable vue/no-v-html -->
<template>
  <transition name="fade">
    <div
      v-if="visible"
      v-report.module="report || {}"
      class="magic-ui-pop v-modal"
      @click="maskCloseHandler"
    >
      <slot v-if="isFull" />
      <div
        v-else
        :id="config.id"
        :class="popClass"
        :style="style"
        @click.stop
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="svg_none"
        >
          <symbol
            id="svg_icon_cancel"
            viewBox="0 0 32 32"
          >
            <path
              d="M17.807 16.326l4.72 4.721c0.232 0.24 0.375 0.567 0.375 0.928 0 0.739-0.599
            1.337-1.337 1.337-0.362 0-0.69-0.144-0.931-0.377l0 0-4.713-4.721-4.72 4.721c-0.24
              0.233-0.569 0.377-0.931 0.377-0.739 0-1.337-0.599-1.337-1.337 0-0.361 0.143-0.688
              0.375-0.929l-0 0 4.72-4.721-4.72-4.721c-0.232-0.24-0.375-0.568-0.375-0.928
                0-0.739 0.599-1.337 1.337-1.337 0.362 0 0.69 0.144 0.931 0.377l4.72 4.721
                4.713-4.721c0.24-0.233 0.569-0.377 0.931-0.377 0.739 0 1.337 0.599
                  1.337 1.337 0 0.361-0.143 0.688-0.375 0.929l0-0z"
            />
          </symbol>
        </svg>
        <i
          v-if="config.closeButton"
          class="svg_icon icon_cancel"
          :style="closeButtonStyle"
          @click="app.closePop(config.id || config.name)"
        >
          <svg class="svg_icon_cancel"><use xlink:href="#svg_icon_cancel" /></svg>
        </i>
        <slot>
          <div
            v-if="config.html"
            class="magic-ui-pop-inner"
            v-html="html"
          />
          <magic-ui-container
            v-else
            class="magic-ui-pop-inner"
            :config="containerConfig"
          />
        </slot>
      </div>
    </div>
  </transition>
</template>

<script>
import { transformStyle } from '@tencent/magic-ui-util/index';
import Vue from 'vue';
import Iscroll from 'iscroll/build/iscroll';
import renderView from '../../../src/mixins/renderView';
const offsetBottom = -100000;
export default {
  name: 'MagicUiPop',

  mixins: [renderView],

  provide() {
    return {
      pop: this,
    };
  },

  inject: {
    app: {
      default: {},
    },
  },

  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },

    isFull: {
      type: Boolean,
      default: false,
    },

    beforeOpen: {
      type: Function,
      default: () => true,
    },

    beforeClose: {
      type: Function,
      default: () => true,
    },

    scroll: {
      type: Boolean,
      default: () => true,
    },
  },

  data() {
    return {
      data: {},

      visible: false,

      hooks: {
        popWillOpen: [],
      },

      iscrolls: [],

      bottom: offsetBottom,
    };
  },

  magicCallerMethods: [
    { label: '显示弹窗', value: 'openFromMagicCaller' },
    { label: '关闭弹窗及遮罩', value: 'closeFromMagicCaller' },
  ],
  magicTriggerEvents: [{
    label: '弹窗关闭通知',
    value: 'popupCloseBroadcast',
  }],

  computed: {
    containerConfig() {
      return {
        style: 'height: 100%;width: 100%',
        items: this.config.items,
      };
    },
    popClass() {
      if (this.config.isFromBottom) {
        return 'magic-ui-pop-content bottom';
      }
      return 'magic-ui-pop-content';
    },

    style() {
      if (!this.config) {
        return '';
      }

      let style = this.config.style || {};

      if (typeof style === 'function') {
        style = style.bind(this)(this, { model: this.model });
      } else {
        const base = ['Hippy-TV', 'TV'].includes(this.app.pageConfig.pageType) ? 1920 : 375;
        style = transformStyle(style, Vue, this.inHippy, base);
      }

      return {
        ...style,
        bottom: `${this.bottom}px`,
      };
    },

    html() {
      if (this.config.html) {
        const res = Vue.compile(this.config.html);

        const vue = new Vue({
          data: this,
          render: res.render,
          staticRenderFns: res.staticRenderFns,
        });
        vue.$mount(document.createElement('div'));

        return vue.$el.innerHTML;
      }
      return '';
    },

    closeButtonStyle() {
      return {
        ...this.config.closeButtonStyle,
        pointerEvents: 'auto',
        color: this.config.closeBtnColor,
      };
    },

    report() {
      return this.config?.report?.module || {};
    },
  },

  watch: {
    async config(v) {
      if (this.inMagic) {
        if (v.isFromBottom) {
          this.bottom = 0;
        }
      }
    },
    async visible(v) {
      if (!v) {
        this.iscrolls.forEach(iscroll => iscroll.destroy());
        return;
      }
      this.$emit('showMagicUiPop');

      if (this.scroll && !this.config.closeIScroll) {
        setTimeout(() => {
          const els = window.$(`#${this.config.id}`).find('*') || [];

          els.forEach && els.forEach((el) => {
            if (el.scrollHeight - el.clientHeight > 2) {
              this.pushIscrollEl(el);
            }
          });
        });
      }

      let { body } = window.document;

      if (this.inMagic && window.parent === window) {
        body = window.document.querySelector('.magic-ui');
      }

      body.appendChild(this.$el);

      if (this.inMagic && v && window.parent === window) {
        this.$nextTick(() => {
          const { style } = this.$el;
          if (style) {
            style.position = 'absolute';
            style.width = '100%';
            style.height = '100%';
          }
        });
      }
    },
  },

  created() {
    this.app.addPop(this);
  },

  mounted() {
    if (this.visible) {
      let { body } = window.document;
      if (this.inMagic) {
        body = window.document.querySelector('.magic-ui');
      }
      body.appendChild(this.$el);
    }
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.app.removePop(this);
  },

  methods: {
    openFromMagicCaller() {
      // 事件联动
      this.app.openPop(this.config.id || this.config.name);
      this.setBottomPxFromBottomStyle(false);
    },
    closeFromMagicCaller() {
      // 事件联动
      this.app.closePop(this.config.id || this.config.name);
      this.setBottomPxFromBottomStyle(true);
    },
    setBottomPxFromBottomStyle(isClose) {
      if (!this.config.isFromBottom) {
        return;
      }
      setTimeout(() => {
        this.bottom = isClose ? offsetBottom : 0;
      });
    },
    pushIscrollEl(el) {
      el.classList.add('iScroll');
      const { children } = el;
      if (children.length > 1) {
        const div = window.document.createElement('div');
        while (el.firstChild) {
          div.appendChild(el.removeChild(el.firstChild));
        }
        el.appendChild(div);
      }
      el.addEventListener('touchmove', this.preventTouchMove);
      this.iscrolls.push(new Iscroll(el, { scrollbars: true }));
    },
    preventTouchMove(e) {
      e.preventDefault();
    },
    async open(data) {
      if (!await this.beforeOpen(this, data)) {
        return false;
      }

      this.visible = true;
      this.data = data;

      const { autoClose, closeSecond, id, name } = this.config;
      if (autoClose && closeSecond) {
        setTimeout(() => {
          this.app.closePop(id || name);
        }, closeSecond * 1000);
      }

      this.$emit('open');
      this.$bus.$emit('magic:component:pop:open', this);
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('magic-pop-opened', {
          detail: { vm: this, config: this.config },
        }));
        document.dispatchEvent(new CustomEvent('tvfocus-change-root', {
          detail: { root: this.$el },
        }));
      });
      this.fixBodyScrollWhenPopShow();
      this.setBottomPxFromBottomStyle(false);
      return true;
    },

    async close() {
      this.rememberLastScrollTop();
      if (!await this.beforeClose(this)) {
        return false;
      }

      this.visible = false;

      document.dispatchEvent(new CustomEvent('tvfocus-change-root', {
        detail: { root: null },
      }));

      this.$emit('close');
      this.$bus.$emit('magic:component:pop:close', this);
      this.$bus.$emit('popupCloseBroadcast', this);
      this.fixBodyScrollWhenPopHide();
      this.setBottomPxFromBottomStyle(true);
      return true;
    },

    maskCloseHandler($event) {
      if ($event.target.className.indexOf('vdr') > -1) {
        return;
      }

      if (typeof this.config.maskClose === 'undefined' || this.config.maskClose) {
        this.app.closePop(this.config.id || this.config.name);
      }
    },

    fixBodyScrollWhenPopShow() {
      const { body } = document;
      body.classList.add('magic-page-when-pop-show');
      this.rememberLastScrollTop();
    },
    rememberLastScrollTop() {
      const { body, documentElement } = document;
      this.lastBodyScrollTop = body.scrollTop || documentElement?.scrollTop || 0;
    },
    fixBodyScrollWhenPopHide() {
      const { body, documentElement } = document;
      body.classList.remove('magic-page-when-pop-show');
      body.scrollTop = this.lastBodyScrollTop;
      if (documentElement) {
        documentElement.scrollTop = this.lastBodyScrollTop - 1;
      }
    },
  },
};
</script>

<style lang="scss">
.magic-page-when-pop-show {
  overflow: hidden;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.magic-ui-pop {
  .magic-ui-pop-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0px);
    border-radius: .16rem;
    background-color: #fff;
    transition: bottom .3s;
    &.bottom {
      top: auto;
      left: 50%;
      transform: translate3d(-50%, 0, 0px);
      border-radius: .16rem .16rem 0 0;
    }
  }

  .icon_cancel {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 24px;
    height: 24px;
    color: #4c5d76;
  }

  .iScroll {
    padding-right: 7px;

    &.magic-ui-text {
      height: 100%;
    }
  }
}
</style>
